import { Flush } from 'domain/constants/ribbons';
import { gu2px } from '@uds/theme-utils';
import { Layout } from 'domain/constants/layout';

/*
  shrinkSide:
    shrink[Leading/Trailing] prop is true then return a reduced padding
    depending on screen size
  isFlush:
    leading or trailing edge has been designated as flush, no padding
*/
const getPaddingSize = ({
  shrinkSide,
  isFlush,
  layout,
  isMinSm,
  isMinLg,
}: {
  shrinkSide: 'shrinkLeading' | 'shrinkTrailing';
  isFlush: boolean;
  layout: Layout;
  isMinSm: boolean;
  isMinLg: boolean;
}) => {
  const { shrinkLeading, shrinkTrailing } = layout;

  const sides = {
    shrinkLeading,
    shrinkTrailing,
  };
  if (isFlush) {
    return 0;
  }

  if (sides[shrinkSide] === true) {
    if (isMinSm) {
      return 1;
    }
    return 0.5;
  }
  if (isMinLg) {
    return 6;
  }
  if (isMinSm) {
    return 5;
  }
  return 4;
};

const getSizes = ({
  flush,
  layout,
  isMinSm,
  isMinLg,
}: {
  flush?: Flush | boolean;
  layout: Layout;
  isMinSm: boolean;
  isMinLg: boolean;
}) => {
  const leading = getPaddingSize({
    shrinkSide: 'shrinkLeading',
    isFlush: flush === Flush.LEADING,
    layout,
    isMinSm,
    isMinLg,
  });
  const trailing = getPaddingSize({
    shrinkSide: 'shrinkTrailing',
    isFlush: flush === Flush.TRAILING,
    layout,
    isMinSm,
    isMinLg,
  });
  return {
    leading,
    trailing,
  };
};

export default ({
  spacing,
  isMinSm,
  isMinLg,
  layout = {},
  flush,
  linariaPadding = false,
}: {
  spacing: number;
  isMinSm: boolean;
  isMinLg: boolean;
  layout?: Layout;
  flush?: Flush | boolean;
  linariaPadding?: boolean;
}) => {
  if (flush === true) {
    // Component will handle all padding, used on full bleed image ribbons
    return {};
  }
  const { leading, trailing } = getSizes({
    flush,
    layout,
    isMinSm,
    isMinLg,
  });

  if (linariaPadding) {
    return { '--centerfold-padding-top': leading, '--centerfold-padding-bottom': trailing };
  }
  return {
    paddingTop: gu2px(leading, spacing),
    paddingBottom: gu2px(trailing, spacing),
  };
};
